/**
 * @file: ErpHostedLogin.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { ErpProviderId } from '../enum';

export type ErpLoginCredentials = {
  username: string;
  password: string;
  /** Only the providers that put a captcha on the login form use this. */
  authCode?: string;
};

export enum ErpHostedLoginStatus {
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
}

/**
 * Outcome of one hosted login attempt, polled by the session id that
 * `submitErpLoginCredential` returned. Never carries the submitted
 * credentials back.
 */
export type ErpHostedLoginResult = {
  sessionId: string;
  status: ErpHostedLoginStatus;
  /** Set once the login lands, and what post-login calls are addressed by. */
  integrationId?: string;
  error?: string;
};

export type ErpHostedLoginRequest = {
  providerId: ErpProviderId;
  credentials: ErpLoginCredentials;
  version?: string;
};
